var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"actions-toolbar flex-grow-0 px-2 d-flex align-center ui-kit-text",style:({
    height: `${_vm.IMAGE_EDITOR_TOOLBAR_HEIGHT}px`,
  })},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }